
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { StepPosition } from '../../joyride.domain';

@Component({
  selector: 'td-wb-joyride-arrow',
  template: '',
  styleUrls: ['./joyride-arrow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JoyrideArrowComponent {
  @Input() position: StepPosition = StepPosition.TOP;

  @HostBinding('class.td-wb-joyride-arrow__top')
  get top(): boolean { return this.position === StepPosition.TOP; }

  @HostBinding('class.td-wb-joyride-arrow__bottom')
  get bottom(): boolean { return this.position === StepPosition.BOTTOM; }

  @HostBinding('class.td-wb-joyride-arrow__right')
  get right(): boolean { return this.position === StepPosition.RIGHT; }

  @HostBinding('class.td-wb-joyride-arrow__left')
  get left(): boolean { return this.position === StepPosition.LEFT; }
}
